<template>
  <div>
    <div class="games_list">
      <div class="games_box" @click="todetail(index)" v-for="(item,index) in gamesList">
        <div class="gamesbox_left">
          <img class="games_img" :src="item.imgurl" />
          <div class="games_des">{{item.name}}</div>
        </div>
        <img class="games_to" src="/static/xiangyou.png" />
      </div>
    </div>
     <!--  <img src="/static/jiuyou.png" /> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        gamesList: [{
            name: "网易游戏兑换券",
            imgurl: "/static/wangyi.png"
          },
          {
            name: "盛大网络充值卡/储值卡",
            imgurl: "/static/shengda.png"
          },
          {
            name: "完美世界充值卡/储值卡",
            imgurl: "/static/wanmei.png"
          },
          {
            name: "空中网充值卡/储值卡",
            imgurl: "/static/kongzhong.png"
          },
          {
            name: "金山充值卡/储值卡",
            imgurl: "/static/jinshan.png"
          },
          {
            name: "搜狐充值卡/储值卡",
            imgurl: "/static/souhugame.png"
          },
          {
            name: "巨人网络充值卡/储值卡",
            imgurl: "/static/juren.png"
          },
          {
            name: "光宇充值卡/储值卡",
            imgurl: "/static/guangyu.png"
          },
          {
            name: "久游充值卡",
            imgurl: "/static/jiuyou.png"
          }
        ]

      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      todetail(e) {
        this.$router.push({
          path: "/gamesDetail",
          query: {
            gamesDetailId: e
          }
        })
      },
    }
  }
</script>

<style>
  .games_list {
    margin: 20px;
  }

  .games_box {
    width: 95%;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #dedede;
    margin-bottom: 20px;
    /* background-image: url(../../../static/aiqiyibanner.png); */
  }

  .gamesbox_left {
    display: flex;
    align-items: center;
  }

  .games_img {
    width: 110px;
    height: 50px;
    border-radius: 25px;
    margin: 10px;
  }

  .games_des {}

  .games_to {
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/games/gamesList.vue